import { Component, OnInit } from "@angular/core";
import { ENV } from "@app/env";
import { Store } from "@ngrx/store";
import { App, LoadingController, MenuController, ModalController, NavController, Platform } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { AuthData } from "../providers/auth";
import { ClientData } from "../providers/client";
import { UserData } from "../providers/user";
import { Utilities } from "../providers/utilities";
import * as sharedActions from "../shared/actions/shared.actions";
import { IClient } from "../shared/models/client.model";
import * as sharedSelectors from "../shared/reducers/shared.reducer";

@Component({
  templateUrl: "app.html",
})
export class RebusAdminApp implements OnInit {

  public rootPage: string;
  public client$: Observable<IClient>;
  public userAdmin$: Observable<any>;
  public version: string;
  public isMode: string = null;

  constructor(
    private platform: Platform,
    private menuCtrl: MenuController,
    private authData: AuthData,
    private userData: UserData,
    private clientData: ClientData,
    private loadingCtrl: LoadingController,
    private appCtrl: App,
    private store: Store<{}>,
    private modalCtrl: ModalController,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.platform.ready().then(() => {
      this.version = ENV.version;
      this.isMode = ENV.mode;
      this.verifiedPrivate();
      this.menuCtrl.enable(false, "main-menu");

      this.authData.getUser().subscribe((currentUser) => {
        if (currentUser) {
          this.utilities.consoleDecorator("[app.component] current user", currentUser);
          // TODO: revisar porque userAdmin$ no se esta suscribiendo en el html
          this.userAdmin$ = this.userData.getUserAdminByUid(currentUser.uid);
          this.client$ = this.store.select(sharedSelectors.getClient);
        }
      });
    });
  }

  private get _navCtrlView(): NavController {
    return this.appCtrl.getActiveNav();
  }

  public logout() {
    this.loadingCtrl.create({
      dismissOnPageChange: true,
    }).present();

    this.store.dispatch(new sharedActions.LoadClientFailed());
    this.menuCtrl.close("main-menu");
    this.authData.logoutUser();
  }

  public goNav(name: string, origin = "menu") {
    this.utilities.consoleDecorator(`[ ${new Date().getTime()} ] - ${origin} - Redirect to: `, name);
    this.rootPage = name;
    this.menuCtrl.close("main-menu");
  }

  public goPush(name: string, clientId) {
    if (name === "ClientFormPage") {
      this._navCtrlView.push(name, { clientId });
      this.menuCtrl.close("main-menu");
    }
  }

  public changeUser(userAdmin) {
    const modal = this.modalCtrl.create(
      "SelectClientPage",
      { currentUser: userAdmin },
      { enableBackdropDismiss: false },
    );
    modal.present();
    modal.onDidDismiss((result) => {
      if (result) {
        if (result.client) {
          const load = this.utilities.setLoading();
          this.clientData.setUserAdminClient(userAdmin.id, result.client.id)
            .then(() => {
              setTimeout(() => {
                window.location.reload(true);
              }, 300);
            })
            .catch((err) => {
              load.dismiss();
              this.utilities.consoleError("Error", err);
            });
        }
      }
    });
  }

  public profile(userAdmin) {
    this.menuCtrl.close("main-menu");
    this.utilities.consoleDecorator("userAdmin", userAdmin);
    this._navCtrlView.push("UserAdministratorFormPage", { administratorId: userAdmin.id });
  }

  public verifiedPrivate() {
    try {
      localStorage.setItem("testPrivateModeRebus", "anyCodeTest");
    } catch (e) {
      alert("You are browsing in private mode.\nPlease disable private mode and return to the page.");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts